webpackJsonp([49],{

/***/ "/Plz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var WMLogo = function WMLogo(props) {
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		'a',
		{
			href: props.href || '/home',
			'aria-label': 'Go to WorkMarket Home'
		},
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
			id: 'adp-wm-logo',
			src: props.logo,
			alt: 'WorkMarket logo',
			'data-attr-id': 'app-logo',
			style: {
				width: 140,
				height: 33,
				marginTop: 4,
				marginLeft: '1rem'
			}
		})
	);
};

/* harmony default export */ __webpack_exports__["a"] = (WMLogo);

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("cx/6");
module.exports = __webpack_require__("a7aZ");


/***/ }),

/***/ "36q6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getMetaInformation = function getMetaInformation(name) {
	return document.querySelector('meta[name="' + name + '"]').getAttribute('content');
};

var userInfo = {};
['userNumber', 'userName', 'firstName', 'userEmail', 'companyNumber', 'companyUuid', 'companyName', 'companyId', 'isBuyer', 'isAdmin', 'isManager', 'isSupport', 'canManageWork'].forEach(function (info) {
	try {
		var metaInfo = getMetaInformation(info);

		if (metaInfo === 'true') {
			metaInfo = true;
		} else if (metaInfo === 'false') {
			metaInfo = false;
		}
		userInfo[info] = metaInfo;
	} catch (exception) {
		console.log('Application is missing ' + info + '.'); // eslint-disable-line no-console
	}
});

/* harmony default export */ __webpack_exports__["a"] = (userInfo);

/***/ }),

/***/ "3FZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var styles = {
	item: { fontFamily: 'Open Sans', color: '#646b6f', fontSize: '16px' },
	labelItem: { fontWeight: 'bold' }
};

/* harmony default export */ __webpack_exports__["a"] = (styles);

/***/ }),

/***/ "3rXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone__ = __webpack_require__("BMgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);



var Events = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.clone(__WEBPACK_IMPORTED_MODULE_0_backbone__["a" /* default */].Events);
Events.trigger = function (event) {
	var _Backbone$Events$trig;

	for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		args[_key - 1] = arguments[_key];
	}

	(_Backbone$Events$trig = __WEBPACK_IMPORTED_MODULE_0_backbone__["a" /* default */].Events.trigger).call.apply(_Backbone$Events$trig, [Events, event].concat(args));
};

/* harmony default export */ __webpack_exports__["a"] = (Events);

/***/ }),

/***/ "4KX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium__ = __webpack_require__("Extj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMTextField__ = __webpack_require__("Pq7z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton__ = __webpack_require__("GkAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_search__ = __webpack_require__("4bvr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities__ = __webpack_require__("CqnY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcs_translation__ = __webpack_require__("94r8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__funcs_fetchRetry__ = __webpack_require__("mEf8");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SearchBar = function (_Component) {
	_inherits(SearchBar, _Component);

	function SearchBar(props) {
		_classCallCheck(this, SearchBar);

		var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

		_this.state = {
			searchValue: "",
			displaySearch: false,
			hasNavBarSearchFeatureToggle: false
		};
		return _this;
	}

	_createClass(SearchBar, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var fetchOptions = function fetchOptions(options, token) {
				return {
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						Authorization: 'Bearer ' + token
					},
					body: JSON.stringify(_extends({}, options))
				};
			};

			/* A feature toggle is used to determine which endpoint is used for the search bar */
			try {
				var navBarSearchSpaFT = 'nav_bar_search_spa';
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__funcs_fetchRetry__["a" /* default */])('/v3/featuretoggle/get', fetchOptions({ featureNames: [navBarSearchSpaFT] })).then(function (response) {
					return response.json();
				}).then(function (data) {
					var featureToggleResult = data.result.payload[0];
					var hasNavBarSearchFeatureToggle = featureToggleResult.name === 'featuretoggle.' + navBarSearchSpaFT && featureToggleResult.enabled;
					_this2.setState({ hasNavBarSearchFeatureToggle: hasNavBarSearchFeatureToggle });
				}, function (error) {
					console.error(error);
				});
			} catch (error) {
				console.error('Attempt to fetch feature toggles failed:', error);
			}
		}
	}, {
		key: 'updateSearchValue',
		value: function updateSearchValue(el) {
			this.setState({ searchValue: el.target.value });
		}
	}, {
		key: 'searchAssignments',
		value: function searchAssignments() {
			if (this.state.hasNavBarSearchFeatureToggle) {
				window.location = '/manage?dashboardTable=%7B"keyword"%3A%5B"' + this.state.searchValue + '"%5D%7D';
			} else {
				window.location = '/assignments/search?keyword=' + encodeURIComponent(this.state.searchValue);
			}
		}
	}, {
		key: 'onSearchIconClick',
		value: function onSearchIconClick() {
			this.state.searchValue ? this.searchAssignments() : this.setState({ displaySearch: !this.state.displaySearch });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var styles = {
				outerDiv: { float: "left" }
			};
			__WEBPACK_IMPORTED_MODULE_5__utilities__["a" /* default */].browser.isSmallMobile() ? styles.TextField = {
				style: { fontFamily: 'Open Sans', color: '#ffffff', width: '152px' },
				inputStyle: { color: '#ffffff', boxShadow: 'none', width: '152px' },
				underlineFocusStyle: { borderColor: '#ffffff', width: '152px' }
			} : styles.TextField = {
				style: {
					color: '#ffffff'
				},
				inputStyle: { color: '#ffffff', boxShadow: 'none' },
				underlineFocusStyle: { borderColor: '#ffffff' },
				hintStyle: { fontFamily: 'Open Sans', size: '14px', color: '#FBCA8E' }
			};

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ style: styles.outerDiv },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton___default.a,
					{ onClick: this.onSearchIconClick.bind(this) },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_action_search___default.a, { color: '#ffffff' })
				),
				this.state.displaySearch ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMTextField___default.a, {
					hintText: __WEBPACK_IMPORTED_MODULE_5__utilities__["a" /* default */].browser.isSmallMobile() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__funcs_translation__["a" /* default */])("translation.search") : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__funcs_translation__["a" /* default */])("translation.search_my_assignments"),
					onKeyDown: function onKeyDown(e) {
						return e.keyCode === 13 && _this3.searchAssignments();
					},
					onChange: function onChange(e) {
						return _this3.updateSearchValue(e);
					},
					inputStyle: styles.TextField.inputStyle,
					style: styles.TextField.style,
					hintStyle: styles.TextField.hintStyle,
					value: this.state.searchValue,
					underlineFocusStyle: styles.TextField.underlineFocusStyle }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
			);
		}
	}]);

	return SearchBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SearchBar = __WEBPACK_IMPORTED_MODULE_1_radium___default()(SearchBar));

/***/ }),

/***/ "5hsw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMSnackbar__ = __webpack_require__("zfs3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMLinearProgress__ = __webpack_require__("XRZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMLinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMLinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_underscore__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








var WMUploader = function WMUploader(_ref) {
	var initialStatus = _ref.status,
	    message = _ref.message;

	var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialStatus),
	    _useState2 = _slicedToArray(_useState, 2),
	    status = _useState2[0],
	    setStatus = _useState2[1];

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
		var timeoutId = null;

		var checkStatus = function checkStatus() {
			__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.getJSON('/uploadProgress/progress', function (res) {
				if (res && res.data && !__WEBPACK_IMPORTED_MODULE_5_underscore___default.a.isUndefined(res.data.uploadProgress)) {
					timeoutId = setTimeout(function () {
						setStatus(res.data.uploadProgress);
					}, 2000);

					if (res.data.uploadProgress === 1) {
						setTimeout(function () {
							return setStatus(0);
						}, 12000);
					}
				} else {
					timeoutId = setTimeout(checkStatus, 5000);
				}
			});
		};

		checkStatus();

		return function () {
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, []);

	if (status > 0 && status < 1) {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMSnackbar___default.a, {
			style: { zIndex: '1200' },
			bodyStyle: { backgroundColor: 'rgba(0, 0, 0, 0.74)' },
			open: !!status,
			message: status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'span',
					null,
					message.done.title
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'span',
					{ style: { paddingLeft: '20px' } },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'a',
						{ href: message.done.link.href },
						message.done.link.text
					)
				)
			) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'span',
					null,
					message.start.title
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMLinearProgress___default.a, {
					style: {
						position: 'absolute',
						top: '24px',
						width: '150px',
						margin: '0 0 0 96px'
					},
					color: '#F79626',
					mode: 'indeterminate'
				})
			)
		});
	}

	return null;
};

/* harmony default export */ __webpack_exports__["a"] = (WMUploader);

/***/ }),

/***/ "7dxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getCookie = function getCookie(name) {
	var result = '';
	var value = ';  ' + document.cookie;
	var parts = value.split('; ' + name + '=');
	if (parts.length === 2) {
		result = parts.pop().split(';').shift();
	}

	return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getCookie);

/***/ }),

/***/ "80dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__ = __webpack_require__("T96S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WMLogo__ = __webpack_require__("/Plz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelpLinksModal__ = __webpack_require__("xuII");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotificationsBtn__ = __webpack_require__("sumK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SwitchModal__ = __webpack_require__("aRfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SupportBannerNew__ = __webpack_require__("9eOq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__funcs_wmFetch__ = __webpack_require__("Nusj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WMUploader__ = __webpack_require__("5hsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities__ = __webpack_require__("CqnY");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














var ShellNavigation = function ShellNavigation(_ref) {
	var showSupportBanner = _ref.showSupportBanner,
	    newConfig = _ref.newConfig;

	var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    localSwitchModal = _useState2[0],
	    setLocalSwitchModal = _useState2[1];

	var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
	    _useState4 = _slicedToArray(_useState3, 2),
	    menuProvider = _useState4[0],
	    setMenuProvider = _useState4[1];

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
		// Set top hat height
		var height = showSupportBanner ? '20px' : '0px';
		document.documentElement.style.setProperty('--top-hat-height', height);

		// Force layout alignment
		__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#outer-container').css('margin-left', '0px');
		__WEBPACK_IMPORTED_MODULE_9_jquery___default()('.site-footer').css('margin-left', '0px');

		// To set Active item in the left nav
		var menuProviderToSet = newConfig.navMenuItems;
		setMenuProvider(menuProviderToSet);

		var menuProviderChildren = menuProviderToSet.flatMap(function (section) {
			return section.children;
		});
		var currentLocation = window.location.pathname.replace(/\/+$/, '');
		var activeItem = menuProviderChildren.find(function (item) {
			return item.hash && item.hash.replace(/\/+$/, '') === currentLocation;
		});

		customElements.whenDefined('sfc-shell-left-nav').then(function () {
			var navNode = document.querySelector('sfc-shell-left-nav');
			if (!navNode) return;

			if (typeof navNode.syncNavigation !== 'function') {
				return;
			}

			if (activeItem) {
				navNode.syncNavigation(activeItem);
			}
		});
	}, [showSupportBanner, newConfig]);

	if (__WEBPACK_IMPORTED_MODULE_11__utilities__["a" /* default */].appBarRemoved()) {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			null,
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WMUploader__["a" /* default */], {
				status: newConfig.uploadStatus,
				message: newConfig.uploadMessage
			})
		);
	}

	var largeUser = newConfig.currentUser;

	var personaLabelMap = {
		BUYER: 'Client',
		SELLER: 'Contractor',
		DISPATCHER: 'Team Agent'
	};

	var getPersonaMode = function getPersonaMode(user) {
		if (!user) return null;
		if (user.buyer) return 'BUYER';
		if (user.seller) return 'SELLER';
		if (user.dispatcher) return 'DISPATCHER';
		return null;
	};

	var _newConfig$currentUse = newConfig.currentUser,
	    isBuyerOrgPayNavigation = _newConfig$currentUse.isBuyerOrgPayNavigation,
	    isSellerOrgPayNavigation = _newConfig$currentUse.isSellerOrgPayNavigation;


	var featureModePay = isBuyerOrgPayNavigation || isSellerOrgPayNavigation;
	var shouldShowSearchAndNotifications = !featureModePay;
	var shouldShowSwitch = !featureModePay; // Change to allowed feature modes check when ready

	var onUserMenuClick = function onUserMenuClick(event) {
		var id = event.detail.action.id;

		if (id === 'PROFILE') window.location.href = '/profile?ref=nav';
		if (id === 'SETTINGS') window.location.href = '/account';
		if (id === 'SWITCH') setLocalSwitchModal(true);
	};

	var onEndSupportSessionClick = function onEndSupportSessionClick() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__funcs_wmFetch__["a" /* default */])('/v3/authSession/authSwitch/end-support-session').then(function (payload) {
			var _payload = _slicedToArray(payload, 1),
			    companyId = _payload[0].companyId;

			window.location.href = '/admin/manage/company/customer_support/' + companyId;
		}).catch(function (error) {
			console.error('Error ending support session', error);
		});
	};

	var handleSearch = function handleSearch(event) {
		var inputValue = event.detail;
		if (!inputValue) return;
		var navFeatureToggle = newConfig.hasNavBarSearchSpaFeature;
		if (navFeatureToggle) {
			window.location = '/manage?dashboardTable=%7B"keyword"%3A%5B"' + inputValue + '"%5D%7D';
		} else {
			window.location = '/assignments/search?keyword=' + inputValue;
		}
	};

	var currentUser = {
		name: largeUser.fullName,
		title: largeUser.email,
		initials: largeUser.fullName.split(' ').map(function (n) {
			return n[0];
		}).join(''),
		avatarUrl: largeUser.smallAvatarUri,
		actions: [{ icon: 'user', label: 'Profile', id: 'PROFILE' }, { icon: 'action-view-settings', label: 'Settings', id: 'SETTINGS' }].concat(_toConsumableArray(shouldShowSwitch ? [{ separator: true }, { icon: 'action-swap', label: personaLabelMap[getPersonaMode(largeUser)], id: 'SWITCH' }] : []))
	};

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
		null,
		showSupportBanner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SupportBannerNew__["a" /* default */], { onEndSession: onEndSupportSessionClick }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["a" /* SfcShellAppBar */],
			{
				slot: 'app-bar',
				size: 'small',
				hasProductLogo: true,
				loggedInUser: currentUser,
				signoutLabel: showSupportBanner ? 'End session' : 'Sign out',
				onSfcSignout: function onSfcSignout() {
					showSupportBanner ? onEndSupportSessionClick() : window.location.href = '/logout?ref=nav';
				},
				onSfcAvatarMenuItemSelected: onUserMenuClick
			},
			shouldShowSearchAndNotifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["b" /* SfcShellAppBarSearch */], { slot: 'search', onSfcSearch: handleSearch, appBarSearchLabel: 'Search my assignments' }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HelpLinksModal__["a" /* default */], {
				useZoomChat: newConfig.useZoomChat,
				useZendesk: newConfig.useZendesk
			}),
			shouldShowSearchAndNotifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NotificationsBtn__["a" /* default */], null),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__WMLogo__["a" /* default */], { logo: newConfig.adpWMlogoURI, href: newConfig.navMenuItems[0].href })
		),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SwitchModal__["a" /* default */], {
			isOpen: localSwitchModal,
			onClose: function onClose() {
				return setLocalSwitchModal(false);
			},
			personaMode: getPersonaMode(largeUser)
		}),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["c" /* SfcShellLeftNav */], { slot: 'nav', menuProvider: menuProvider }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__WMUploader__["a" /* default */], {
			status: newConfig.uploadStatus,
			message: newConfig.uploadMessage
		})
	);
};

ShellNavigation.defaultProps = {
	showSwitchModal: false
};

/* harmony default export */ __webpack_exports__["a"] = (ShellNavigation);

/***/ }),

/***/ "94r8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translation_lang_en__ = __webpack_require__("WZmK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translation_lang_es__ = __webpack_require__("UbF2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getCookie__ = __webpack_require__("7dxP");
/* harmony export (immutable) */ __webpack_exports__["a"] = translate;




function format(str, params) {
	var formattedStr = str;
	for (var i = 0; i < params.length; i += 1) {
		var regexp = new RegExp('\\{' + i + '\\}', 'gi');
		formattedStr = formattedStr.replace(regexp, params[i]);
	}
	return formattedStr;
}

function translate(key) {
	var lang = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getCookie__["a" /* default */])('lang');

	var translation = '!!! ' + key + ' !!!';
	if (__WEBPACK_IMPORTED_MODULE_0__translation_lang_en__["a" /* default */][key] !== undefined) {
		translation = __WEBPACK_IMPORTED_MODULE_0__translation_lang_en__["a" /* default */][key];
	}

	if (lang === 'es' && __WEBPACK_IMPORTED_MODULE_1__translation_lang_es__["a" /* default */][key] !== undefined) {
		translation = __WEBPACK_IMPORTED_MODULE_1__translation_lang_es__["a" /* default */][key];
	}

	for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		params[_key - 1] = arguments[_key];
	}

	if (params.length) {
		translation = format(translation, params);
	}
	return translation;
}

/***/ }),

/***/ "9cOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem__ = __webpack_require__("qt5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__("3FZT");





var DefaultChatMenu = function DefaultChatMenu(_ref) {
	var support = _ref.support,
	    useZendesk = _ref.useZendesk;
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
		null,
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-help-center',
			href: 'https://workmarket.zendesk.com/hc/en-us',
			target: '_blank',
			primaryText: 'Help Center',
			style: __WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].item
		}),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-support-email',
			href: support.emailHref,
			primaryText: support.emailText,
			style: __WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].item
		}),
		!!useZendesk && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-chat',
			onClick: function onClick() {
				window.zE('webWidget', 'show'); // eslint-disable-line no-undef
				window.zE('webWidget', 'open'); // eslint-disable-line no-undef
			},
			primaryText: 'Chat with us',
			style: __WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].item
		}),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-phone',
			href: support.phoneHref,
			primaryText: support.phoneText,
			style: __WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].item
		}),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-status-page',
			href: 'https://status.workmarket.com',
			primaryText: 'Status Page',
			style: __WEBPACK_IMPORTED_MODULE_3__styles__["a" /* default */].item
		})
	);
};

DefaultChatMenu.defaultProps = {
	support: {},
	useZendesk: false
};

/* harmony default export */ __webpack_exports__["a"] = (DefaultChatMenu);

/***/ }),

/***/ "9eOq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__ = __webpack_require__("T96S");




var SupportBannerNew = function SupportBannerNew(_ref) {
	var onEndSession = _ref.onEndSession;

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["k" /* SfcShellTopHat */],
		{ slot: 'top-hat', className: 'w-full flex items-center justify-center', 'data-attr-id': 'wm-support-banner' },
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			null,
			'You are logged in as WorkMarket Support, and any actions taken will be logged.'
		),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{
				'data-attr-id': 'wm-support-banner-btn',
				tabIndex: '0',
				role: 'button',
				className: 'ml-6 text-sm underline cursor-pointer',
				onKeyDown: onEndSession,
				onClick: onEndSession
			},
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["j" /* SdfIcon */], { icon: 'action-logout', className: 'text-inverse-default mr-2' }),
			'End session'
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (SupportBannerNew);

/***/ }),

/***/ "BMgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js__ = __webpack_require__("aGLy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);



'use strict';

// Compatibility override - Backbone 1.1 got rid of the automatic 'options' binding
// on Views - we need to keep that.
__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default.a.View = function (View) {
	return View.extend({
		constructor: function constructor(options) {
			this.options = options || {};
			View.apply(this, arguments);
		}
	});
}(__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default.a.View);

__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default.a.Collection = function (Collection) {
	return Collection.extend({
		fetch: function fetch(options) {
			return Collection.prototype.fetch.call(this, __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.extend(options, { reset: true }));
		}
	});
}(__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default.a.Collection);

__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default.a.syncWithJSON = function (method, model, options) {
	__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default.a.sync.call(this, method, model, __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.extend(options, { emulateJSON: false }));
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_backbone_backbone_js___default.a);

/***/ }),

/***/ "CqnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);

var utils = {};

utils.getCSRFToken = function () {
	return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.find(document.getElementsByTagName("meta"), function (meta) {
		return meta.name === "csrf-token";
	}).content;
};

utils.checkStatus = function (res) {
	if (res.status >= 200 && res.status < 300) {
		return res;
	} else {
		var error = new Error(res.statusText);
		error.res = res;
		throw error;
	}
};

utils.browser = {
	isDesktop: function isDesktop() {
		return screen.width > 1025;
	},
	isSmallMobile: function isSmallMobile() {
		return screen.width < 520;
	}
};

utils.appBarRemoved = function () {
	return window && window.navConfig && (window.navConfig.isAppBarRemoved === true || window.navConfig.isMonolithAppBarRemoved === true);
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ "D/33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_google_recaptcha__ = __webpack_require__("nT0y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__workmarket_front_end_components_dist_WMPaper__ = __webpack_require__("lJ/E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__workmarket_front_end_components_dist_WMPaper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__workmarket_front_end_components_dist_WMPaper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMRaisedButton__ = __webpack_require__("Sfwl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMRaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMRaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSelectField__ = __webpack_require__("kyRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField__ = __webpack_require__("wsNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMValidatingForm__ = __webpack_require__("TtKq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMValidatingForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMValidatingForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMLink__ = __webpack_require__("LxX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem__ = __webpack_require__("qt5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMMessageBanner__ = __webpack_require__("HQOJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMMessageBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMMessageBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__workmarket_front_end_components_dist_WMHeading__ = __webpack_require__("iXge");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__workmarket_front_end_components_dist_WMHeading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__workmarket_front_end_components_dist_WMHeading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__workmarket_front_end_components_dist_WMCheckbox__ = __webpack_require__("0JAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__workmarket_front_end_components_dist_WMCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__workmarket_front_end_components_dist_WMCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__workmarket_wm_company_pages_spa__ = __webpack_require__("95fg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__workmarket_wm_company_pages_spa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__workmarket_wm_company_pages_spa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles__ = __webpack_require__("m3YH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__core__ = __webpack_require__("E/D/");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable indent */
/* eslint-disable react/require-default-props */

















var USER_TYPE = {
	INDIVIDUAL: 1,
	COMPANY: 2
};

var LandingPage = function (_Component) {
	_inherits(LandingPage, _Component);

	function LandingPage(props) {
		_classCallCheck(this, LandingPage);

		var _this = _possibleConstructorReturn(this, (LandingPage.__proto__ || Object.getPrototypeOf(LandingPage)).call(this, props));

		_this.getFormData = function (object) {
			var resetForm = Object.keys(object).reduce(function (formData, key) {
				formData.append(key, object[key]);
				return formData;
			}, new FormData());
			resetForm.append('termsAgree', _this.state.termsAgree);
			return resetForm;
		};

		_this.fetchIndustries = function () {
			return fetch('/api/v1/constants/industries', { credentials: 'same-origin' }).then(function (res) {
				return res.ok ? res.json() : [];
			}).then(function (res) {
				var industriesList = res.response.map(function (industry) {
					return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem___default.a, {
						key: industry.id,
						value: industry.id,
						primaryText: industry.name
					});
				});
				_this.setState({ industries: industriesList });
			});
		};

		_this.fetchCountries = function () {
			return fetch('/country-list', { credentials: 'same-origin' }).then(function (res) {
				return res.ok ? res.json() : [];
			}).then(function (res) {
				var countries = res;

				var countryList = Object.keys(countries).map(function (iso3) {
					return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem___default.a, {
						key: iso3,
						value: iso3,
						primaryText: countries[iso3]
					});
				});
				_this.setState({ countries: countryList });
			});
		};

		_this.handleChange = function (name, value) {
			var updated = {};
			updated[name] = value;
			_this.setState(updated);
		};

		_this.handleIndustryChange = function (event, index, value) {
			_this.setState({ industryId: value });
		};

		_this.handleCaptchaChange = function (isValid) {
			_this.setState({ isCaptchaValid: Boolean(isValid) });
		};

		_this.handleCountryChange = function (event, index, value) {
			_this.setState({ countryOfResidence: value });
		};

		_this.state = {
			showForm: false,
			showError: false,
			errorMessage: '',
			firstName: '',
			lastName: '',
			email: '',
			password: '',
			companyName: '',
			industryId: '',
			userType: '',
			termsAgree: false,
			isCaptchaValid: false,
			countryOfResidence: ''
		};
		return _this;
	}

	_createClass(LandingPage, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.fetchIndustries();
			this.fetchCountries();
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit(form) {
			var _this2 = this;

			var isCaptchaValid = this.state.isCaptchaValid;


			if (!isCaptchaValid) return;

			this.clearErrors();
			if (this.isCompany() && !this.props.isInvitation) {
				this.submitCompanyForm(form);
			} else {
				var REGISTER_URL = this.props.isInvitation ? '/register/invitation/' + this.props.encryptedId : '/register/campaign/' + this.props.encryptedId;
				fetch(REGISTER_URL, {
					method: 'POST',
					credentials: 'same-origin',
					body: this.getFormData(form),
					headers: {
						'X-CSRF-Token': __WEBPACK_IMPORTED_MODULE_15__core__["a" /* default */].CSRFToken
					}
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					if (response && response.successful) {
						_this2.redirectToSuccessPage();
					} else {
						_this2.unexpectedException(response.results || response);
					}
				}).catch(function () {
					_this2.unexpectedException();
				});
			}
		}
	}, {
		key: 'clearErrors',
		value: function clearErrors() {
			this.setState({ showError: false, errorMessage: '' });
		}
	}, {
		key: 'submitCompanyForm',
		value: function submitCompanyForm(form) {
			var _this3 = this;

			var COMPANY_REGISTER_URL = '/v2/employer/create-account/' + this.props.encryptedId;
			fetch(COMPANY_REGISTER_URL, {
				method: 'POST',
				credentials: 'same-origin',
				body: JSON.stringify(_extends({}, form, { userEmail: form.email, termsAgree: this.state.termsAgree })),
				headers: {
					'X-CSRF-Token': __WEBPACK_IMPORTED_MODULE_15__core__["a" /* default */].CSRFToken
				}
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				if (response && response.meta.code === 200) {
					_this3.redirectToSuccessPage();
				} else {
					_this3.unexpectedException(response.results || response);
				}
			}).catch(function () {
				_this3.unexpectedException();
			});
		}
	}, {
		key: 'redirectToSuccessPage',
		value: function redirectToSuccessPage() {
			window.location = this.props.isInvitation ? '/register/thankyou/?i=' + this.props.encryptedId : '/register/thankyou/?c=' + this.props.encryptedId;
		}
	}, {
		key: 'unexpectedException',
		value: function unexpectedException(unidentfiedError) {
			var errorMessage = void 0;
			if (Array.isArray(unidentfiedError)) {
				errorMessage = unidentfiedError.map(function (error) {
					return error.message;
				}).join(' ');
			} else {
				errorMessage = unidentfiedError.messages[0];
			}
			this.setState({
				showError: true,
				errorMessage: errorMessage || 'An unexpected error occurred.'
			});
		}
	}, {
		key: 'toggleForm',
		value: function toggleForm(userType) {
			if (this.state.showForm && this.state.userType !== userType) {
				this.setState({ showForm: true, userType: userType });
			} else {
				this.setState({ showForm: !this.state.showForm, userType: userType
				});
			}
		}
	}, {
		key: 'isCompany',
		value: function isCompany() {
			return this.state.userType === USER_TYPE.COMPANY;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
				'div',
				null,
				__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_1__workmarket_front_end_components_dist_WMPaper___default.a,
					{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].landingPageHeader },
					__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
						'div',
						{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].landingPageText },
						'You\'re invited to join our network on Work Market.'
					),
					__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
						'div',
						{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].landingPageButtonContainer },
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
							'div',
							{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].buttonContainer },
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMRaisedButton___default.a, {
								fullWidth: true,
								onClick: function onClick() {
									return _this4.toggleForm(USER_TYPE.COMPANY);
								},
								label: 'Join as a company*',
								secondary: true
							}),
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
								'div',
								{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].tinyText },
								'* EIN required'
							)
						),
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
							'div',
							{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].buttonContainer },
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMRaisedButton___default.a, {
								fullWidth: true,
								onClick: function onClick() {
									return _this4.toggleForm(USER_TYPE.INDIVIDUAL);
								},
								label: 'Join as an individual',
								secondary: true
							})
						)
					)
				),
				__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_1__workmarket_front_end_components_dist_WMPaper___default.a,
					{
						transitionEnabled: true,
						style: this.state.showForm ? __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].formContainer : __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].hideForm
					},
					__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
						__WEBPACK_IMPORTED_MODULE_9__workmarket_front_end_components_dist_WMHeading___default.a,
						{ level: '3' },
						'Sign Up for Work Market'
					),
					this.state.showError && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
						__WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMMessageBanner___default.a,
						{
							hideDismiss: true,
							status: 'error'
						},
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
							'p',
							{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].landingPageError },
							this.state.errorMessage
						)
					),
					__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
						__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMValidatingForm___default.a,
						{
							onSubmit: function onSubmit(form) {
								return _this4.onSubmit(form);
							},
							submitText: 'Register',
							disabled: !this.state.termsAgree || !this.state.isCaptchaValid
						},
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField___default.a, {
							required: true,
							fullWidth: true,
							floatingLabelText: 'First Name',
							id: 'firstname',
							name: 'firstName',
							errorName: 'first name',
							value: this.state.firstName,
							onChange: this.handleChange
						}),
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField___default.a, {
							required: true,
							fullWidth: true,
							floatingLabelText: 'Last Name',
							id: 'lastname',
							name: 'lastName',
							errorName: 'last name',
							value: this.state.lastName,
							onChange: this.handleChange
						}),
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField___default.a, {
							required: true,
							fullWidth: true,
							criteria: 'email',
							floatingLabelText: (this.isCompany() ? 'Company' : '') + ' Email',
							id: 'email',
							name: 'email',
							errorName: (this.isCompany() ? 'company' : '') + ' email',
							value: this.state.email,
							onChange: this.handleChange
						}),
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField___default.a, {
							required: true,
							fullWidth: true,
							floatingLabelText: 'Password',
							hintText: 'Min 8 characters, at least 1 number',
							min: 8,
							id: 'password',
							name: 'password',
							type: 'password',
							errorName: 'password',
							value: this.state.password,
							onChange: this.handleChange
						}),
						this.isCompany() && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__workmarket_front_end_components_dist_WMValidatingTextField___default.a, {
								required: true,
								fullWidth: true,
								floatingLabelText: 'Company Name',
								id: 'companyName',
								name: 'companyName',
								errorName: 'company name',
								value: this.state.companyName,
								onChange: this.handleChange
							}),
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSelectField___default.a,
								{
									required: true,
									id: 'industryId',
									name: 'industryId',
									fullWidth: true,
									floatingLabelText: 'Choose Industry',
									value: this.state.industryId,
									onChange: this.handleIndustryChange
								},
								this.state.industries
							),
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSelectField___default.a,
								{
									required: true,
									id: 'countryOfResidence',
									name: 'countryOfResidence',
									fullWidth: true,
									floatingLabelText: 'Choose Country of Residence',
									value: this.state.countryOfResidence,
									onChange: this.handleCountryChange
								},
								this.state.countries
							)
						),
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
							'div',
							{ style: { display: 'flex', alignItems: 'left', justifyContent: 'flex-start', paddingTop: '15px' } },
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__workmarket_front_end_components_dist_WMCheckbox___default.a, {
								style: { width: '40px' },
								id: 'concent',
								checked: this.state.termsAgree,
								onCheck: function onCheck(e, isInputChecked) {
									return _this4.handleChange('termsAgree', isInputChecked);
								}
							}),
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
								'small',
								{ style: { fontSize: '14px' } },
								'I have read and hereby agree to the WorkMarket',
								__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
								__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
									__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMLink___default.a,
									{ href: '/tos' },
									'Terms of Use Agreement'
								),
								'\xA0and consent to the',
								__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('br', null),
								__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
									__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMLink___default.a,
									{ href: '/privacy' },
									'Privacy Statement'
								)
							)
						),
						__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
							'div',
							{ style: { paddingTop: '20px' } },
							__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_google_recaptcha__["a" /* default */], {
								sitekey: this.props.googleRecaptchaSiteKey,
								onChange: this.handleCaptchaChange
							})
						)
					)
				),
				this.props.isInvitation !== true && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_1__workmarket_front_end_components_dist_WMPaper___default.a,
					{ style: __WEBPACK_IMPORTED_MODULE_14__styles__["a" /* default */].descriptionContainer },
					__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement('div', {
						dangerouslySetInnerHTML: // eslint-disable-line react/no-danger
						{ __html: this.props.campaignText }
					}),
					' '
				),
				__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__workmarket_wm_company_pages_spa___default.a, {
					compact: true,
					isPublic: true,
					companyNumber: this.props.companyNumber,
					csrf: this.props.csrf
				})
			);
		}
	}]);

	return LandingPage;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LandingPage);

/***/ }),

/***/ "E/D/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone__ = __webpack_require__("BMgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__("3rXp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metrics__ = __webpack_require__("PlYB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sync__ = __webpack_require__("uHhO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__csrf__ = __webpack_require__("JZtJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_info__ = __webpack_require__("36q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__funcs_ajaxSendInit__ = __webpack_require__("vEsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__featureFlags__ = __webpack_require__("yg9a");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__funcs_ajaxSendInit__["a" /* default */])();

var Application = function () {
	function Application() {
		_classCallCheck(this, Application);

		this.CSRFToken = __WEBPACK_IMPORTED_MODULE_4__csrf__["a" /* default */];
		this.UserInfo = __WEBPACK_IMPORTED_MODULE_5__user_info__["a" /* default */];
		this.Sync = __WEBPACK_IMPORTED_MODULE_3__sync__["a" /* default */];
		this.Events = __WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */];

		/**
   * Resolve a promise which returns an object of flags with their enabled/disabled value
   * The value is coming from `context.jsp` which populates the flag value in the window scope
   *
   * Note: This originally fetched flag values from settings-service, but at this time we do
   * not want to make gateway calls.
   */
		this.featureFlags = new Promise(function (resolve) {
			resolve(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__featureFlags__["a" /* ORG_STRUCTURE */], window.workmarket.isOrgEnabled));
		});
	}

	_createClass(Application, [{
		key: 'init',
		value: function init(_ref, Router) {
			var name = _ref.name,
			    features = _ref.features,
			    data = _ref.data;

			if (__WEBPACK_IMPORTED_MODULE_0_backbone__["a" /* default */].History.started) {
				console.warn('Application has already been initialized.'); // eslint-disable-line no-console
				return;
			}

			this.name = name;
			this.Metrics = new __WEBPACK_IMPORTED_MODULE_2__metrics__["a" /* default */](this);
			if (features) {
				this.Features = features;
				Object.freeze(this.Features);
			}
			if (data) {
				this.Data = data;
				Object.freeze(this.Data);
			}

			new Router(); // eslint-disable-line no-new

			this.Events.trigger('application:initialize');
			this.Metrics.monitor('application:initialize');
			if (window.performance && window.performance.timing) {
				var navigationStart = window.performance.timing.navigationStart;

				this.Metrics.monitor('application:initializeTiming', Date.now() - navigationStart);
			}
		}
	}]);

	return Application;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Application());

/***/ }),

/***/ "El2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMIconMenu__ = __webpack_require__("xP5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMIconMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMIconMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton__ = __webpack_require__("GkAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_hardware_headset_mic__ = __webpack_require__("6EOE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_hardware_headset_mic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_hardware_headset_mic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DefaultChatMenu__ = __webpack_require__("9cOn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SupportMenuItems__ = __webpack_require__("G5UI");
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var SocialChatMenu = function SocialChatMenu(_ref) {
	var useZoomChat = _ref.useZoomChat,
	    props = _objectWithoutProperties(_ref, ['useZoomChat']);

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMIconMenu___default.a,
		{
			anchorOrigin: { horizontal: 'right', vertical: 'top' },
			className: 'app-social-menu',
			iconButtonElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconButton___default.a,
				{
					className: 'app-social-menu-btn',
					style: { verticalAlign: 'middle' }
				},
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_hardware_headset_mic___default.a, { color: '#ffffff' })
			),
			targetOrigin: { horizontal: 'right', vertical: 'top' }
		},
		useZoomChat ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SupportMenuItems__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DefaultChatMenu__["a" /* default */], props)
	);
};

SocialChatMenu.defaultProps = {
	useZoomChat: false
};

/* harmony default export */ __webpack_exports__["a"] = (SocialChatMenu);

/***/ }),

/***/ "G5UI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem__ = __webpack_require__("qt5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_drop_right__ = __webpack_require__("Wbk8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_drop_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_drop_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__("3FZT");






var SupportMenuItems = function SupportMenuItems(_ref) {
	var support = _ref.support,
	    useZendesk = _ref.useZendesk;
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
		null,
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-help-center',
			href: 'https://workmarket.zendesk.com/hc/en-us',
			primaryText: 'Help Center',
			style: __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* default */].item,
			target: '_blank'
		}),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-get-help',
			menuItems: [!!useZendesk // eslint-disable-line no-extra-boolean-cast
			? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
				className: 'app-social-menu-chat',
				id: 'menu-chat-button',
				onClick: function onClick() {
					if (window.zoomCampaignSdk) {
						window.zoomCampaignSdk.open();
						window.zoomCampaignSdk.show();
						window.zoomCampaignSdk.on('close', function () {
							return window.zoomCampaignSdk.hide();
						});
					}
				},
				primaryText: 'Chat with us',
				style: __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* default */].item
			}) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
				className: 'app-social-menu-phone',
				href: support.phoneHref,
				primaryText: support.phoneText,
				style: __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* default */].item
			})],
			primaryText: 'Get Help',
			rightIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_svg_icons_navigation_arrow_drop_right___default.a, null),
			style: __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* default */].item
		}),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
			className: 'app-social-menu-status-page',
			href: 'https://status.workmarket.com',
			primaryText: 'Status Page',
			style: __WEBPACK_IMPORTED_MODULE_4__styles__["a" /* default */].item
		})
	);
};

SupportMenuItems.defaultProps = {
	support: {},
	useZendesk: false
};

/* harmony default export */ __webpack_exports__["a"] = (SupportMenuItems);

/***/ }),

/***/ "J6J4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["a"] = (function () {

	var selector = 'meta[name="csrf-token"]';
	var $meta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selector);
	if ($meta.length === 0) {
		$meta = window.parent.$(selector);
	}

	return $meta.attr('content');
});

/***/ }),

/***/ "JZtJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getMetaInformation = function getMetaInformation(name) {
	return document.querySelector('meta[name="' + name + '"]').getAttribute('content');
};

var getCSRFToken = function getCSRFToken() {
	try {
		var token = getMetaInformation('csrf-token');
		return token;
	} catch (exception) {
		return console.warn('Application is missing a CSRF token.'); // eslint-disable-line no-console
	}
};

var CSRFToken = getCSRFToken();

/* harmony default export */ __webpack_exports__["a"] = (CSRFToken);

/***/ }),

/***/ "KJQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMIconMenu__ = __webpack_require__("xP5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMIconMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMIconMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMFontIcon__ = __webpack_require__("yWpH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMFontIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMFontIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem__ = __webpack_require__("qt5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMDivider__ = __webpack_require__("ajST");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities__ = __webpack_require__("CqnY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__funcs_ajaxSendInit__ = __webpack_require__("vEsa");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SocialNotificationsMenu = function (_Component) {
	_inherits(SocialNotificationsMenu, _Component);

	function SocialNotificationsMenu(props) {
		_classCallCheck(this, SocialNotificationsMenu);

		var _this = _possibleConstructorReturn(this, (SocialNotificationsMenu.__proto__ || Object.getPrototypeOf(SocialNotificationsMenu)).call(this, props));

		_this.state = {
			notifications: [],
			unreadCount: 0,
			unreadStartId: 0,
			unreadEndId: 0
		};
		return _this;
	}

	_createClass(SocialNotificationsMenu, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.loadNotifications();
			this.getUnreadNotificationCount();
		}
	}, {
		key: 'loadNotifications',
		value: function loadNotifications() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()('/notifications/list', {
				credentials: 'same-origin'
			}).then(__WEBPACK_IMPORTED_MODULE_9__utilities__["a" /* default */].checkStatus).then(function (res) {
				return res.json();
			}).then(function (unprocessedNotifications) {
				var parseHref = function parseHref(str) {
					var matches = str.match(/href="([^"]*)/);
					return matches ? matches[1] : "";
				};
				var preparedNotifications = unprocessedNotifications.map(function (item) {
					return {
						primaryText: item.display_message.replace(/<[^>]*>/g, ''),
						href: parseHref(item.display_message),
						createdOn: item.created_on,
						viewed: item.viewed
					};
				});
				_this2.setState({ notifications: preparedNotifications });
			});
		}
	}, {
		key: 'getUnreadNotificationCount',
		value: function getUnreadNotificationCount() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()('/notifications/unread_notifications', {
				credentials: 'same-origin'
			}).then(__WEBPACK_IMPORTED_MODULE_9__utilities__["a" /* default */].checkStatus).then(function (res) {
				return res.json();
			}).then(function (res) {
				if (res.data !== undefined && !__WEBPACK_IMPORTED_MODULE_3_underscore___default.a.isUndefined(res.data.notifications)) {
					var unreadNotificationsInfo = res.data.notifications;
					_this3.setState({ unreadCount: unreadNotificationsInfo.unreadCount });
					_this3.setState({ unreadStartId: unreadNotificationsInfo.startUuid });
					_this3.setState({ unreadEndId: unreadNotificationsInfo.endUuid });
				} else {
					_this3.setState({ unreadCount: 0 });
					_this3.setState({ unreadStartId: 0 });
					_this3.setState({ unreadEndId: 0 });
				}
			});
		}
	}, {
		key: 'updateViewedNotifications',
		value: function updateViewedNotifications() {
			var _this4 = this;

			if (this.state.unreadStartId && this.state.unreadEndId) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__funcs_ajaxSendInit__["a" /* default */])();
				__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({
					type: 'POST',
					url: '/notifications/all_viewed',
					dataType: 'json',
					data: {
						startUuid: this.state.unreadStartId,
						endUuid: this.state.unreadEndId
					},
					success: function success() {
						_this4.setState({ unreadStartId: 0 });
						_this4.setState({ unreadEndId: 0 });
						_this4.setState({ unreadCount: 0 });
					}
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			var styles = {
				iconButton: {
					verticalAlign: 'middle'
				},
				socialNotificationsCount: {
					display: 'inline-block',
					position: 'absolute',
					backgroundColor: 'rgb(62, 145, 224)',
					border: 'solid 1px rgb(255, 255, 255)',
					fontFamily: 'OpenSans-Semibold',
					fontSize: '10px',
					WebkitFontSmoothing: 'subpixel-antialiased',
					color: 'rgb(255, 255, 255)',
					lineHeight: '1.1',
					borderRadius: '14px',
					marginLeft: '-8px',
					padding: '1px 3px',
					top: '-12px',
					right: '-9px'
				}
			};

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMIconMenu___default.a,
				{
					width: 360,
					menuStyle: { fontFamily: 'Open Sans', zIndex: 1200, maxHeight: '470px', overflow: 'auto' },
					onClick: function onClick() {
						return _this5.updateViewedNotifications();
					},
					iconButtonElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: styles.iconButton },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMFontIcon___default.a,
							{ className: 'material-icons', color: '#ffffff' },
							'notifications',
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								{ style: styles.socialNotificationsCount },
								this.state.unreadCount || 0
							)
						)
					),
					anchorOrigin: { horizontal: 'right', vertical: 'top' },
					targetOrigin: { horizontal: 'right', vertical: 'top' }
				},
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem___default.a, {
					primaryText: 'Notifications',
					secondaryText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'a',
						{ style: { fontFamily: 'Open Sans', color: '#1890e0' }, href: '/notifications/active' },
						'View All'
					),
					disabled: true,
					style: { color: '#646b6f' }
				}),
				this.state.notifications.length ? this.state.notifications.map(function (item, index) {
					return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ key: index },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMDivider___default.a, {
							style: { width: '100%' }
						}),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem___default.a, {
							style: { fontFamily: 'Open Sans', color: '#646b6f', lineHeight: '28px', whiteSpace: 'normal', paddingTop: '10px' },
							href: item.href,
							primaryText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								null,
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { style: { lineHeight: '20px', marginBottom: '0px', fontFamily: 'Open Sans' }, dangerouslySetInnerHTML: { __html: item.primaryText } }),
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'small',
									{ style: item.viewed ? { fontFamily: 'Open Sans', color: '#8D9092' } : { fontFamily: 'Open Sans', color: '#F79626' }, className: 'meta' },
									!item.viewed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon-circle', id: 'notification_status' }),
									' ',
									__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.createdOn).fromNow()
								)
							)
						})
					);
				}) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__workmarket_front_end_components_dist_WMDivider___default.a, {
						style: { width: '100%' }
					}),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMMenuItem___default.a, {
						style: { fontFamily: 'Open Sans', color: '#646b6f' },
						primaryText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: { fontFamily: 'Open Sans' } },
							'No new notifications. ',
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
							'You may configure your notifications settings',
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'a',
								{ href: '/mysettings/notifications' },
								' here'
							),
							'.'
						)
					})
				)
			);
		}
	}]);

	return SocialNotificationsMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SocialNotificationsMenu);

/***/ }),

/***/ "Nusj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getBearerToken__ = __webpack_require__("R8JQ");
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/**
 * WorkMarket V3 API helper fetch function.
 *
 * @param {String} url - The request URL endpoint
 * @param {Object} payload - The object that will be POST to the URL specified
 * @param {Object} options - Specify internal options
 * @param {boolean} includeEntireResult - When set to `true`, the `result` object from the response will be returned. Otherwise, only the payload array will be returned.
 *
 * @returns {Promise} Returns a promise with the response payload if resolved.
 */
var wmFetch = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, payload) {
		var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var includeEntireResult = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
		var fetchOptions, apiToken, response, data, result;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						fetchOptions = function fetchOptions(optionsOverride, token) {
							var defaultOptions = {
								credentials: 'same-origin',
								method: 'POST',
								headers: {
									'Content-Type': 'application/json; charset=utf-8',
									Authorization: 'Bearer ' + token
								},
								body: JSON.stringify(payload)
							};
							return _extends({}, defaultOptions, optionsOverride);
						};

						_context.prev = 1;
						_context.next = 4;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getBearerToken__["a" /* default */])();

					case 4:
						apiToken = _context.sent;
						_context.next = 7;
						return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, fetchOptions(options, apiToken));

					case 7:
						response = _context.sent;
						_context.next = 10;
						return response.json();

					case 10:
						data = _context.sent;
						result = data.result;

						if (!(Array.isArray(result.errors) && result.errors.length)) {
							_context.next = 14;
							break;
						}

						throw new Error(result.errors[0].message);

					case 14:
						if (!Array.isArray(result.payload)) {
							_context.next = 16;
							break;
						}

						return _context.abrupt('return', includeEntireResult ? result : result.payload);

					case 16:
						throw new Error('API responded with an invalid V3 payload.');

					case 19:
						_context.prev = 19;
						_context.t0 = _context['catch'](1);
						throw _context.t0;

					case 22:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, _this, [[1, 19]]);
	}));

	return function wmFetch(_x3, _x4) {
		return _ref.apply(this, arguments);
	};
}();

/* harmony default export */ __webpack_exports__["a"] = (wmFetch);

/***/ }),

/***/ "PlYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone__ = __webpack_require__("BMgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sync__ = __webpack_require__("uHhO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_info__ = __webpack_require__("36q6");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






// Data Store //
var setEvents = function setEvents(namespace, events) {
	return localStorage.setItem(namespace, JSON.stringify(events));
};
var getEvents = function getEvents(namespace) {
	return JSON.parse(localStorage.getItem(namespace) || '[]');
};
var clearEvents = function clearEvents(namespace) {
	return localStorage.removeItem(namespace);
};

var getMonitoringEvent = function getMonitoringEvent(name, events, args) {
	var value = args.value;

	var monitoringEvent = void 0;
	value = (name + '.' + value).replace(':', '.');

	monitoringEvent = events.find(function (event) {
		return event.value === value;
	});
	if (monitoringEvent) {
		monitoringEvent.count += 1;
	} else {
		monitoringEvent = Object.assign({}, args, { value: value });
	}

	return monitoringEvent;
};

// Server Communication //
var MonitoringModel = __WEBPACK_IMPORTED_MODULE_0_backbone__["a" /* default */].Model.extend({
	idAttribute: 'value',
	defaults: {
		type: 'meter',
		count: 1
	}
});

var MonitoringCollection = __WEBPACK_IMPORTED_MODULE_0_backbone__["a" /* default */].Collection.extend({
	model: MonitoringModel,
	url: '/metrics',
	send: function send() {
		this.reset(getEvents('monitoring'));
		__WEBPACK_IMPORTED_MODULE_2__sync__["a" /* default */].call(this, 'create', this);
		this.reset();
		clearEvents('monitoring');
	}
});

var metrics = new MonitoringCollection();

var send = function send(namespace) {
	if (namespace === 'monitoring') {
		metrics.send();
	} else if (namespace === 'segment') {
		console.warn('Segment isn\'t hooked up yet.'); // eslint-disable-line no-console
	}
};

var sendEvents = send;
var throttleOutgoingEvents = function throttleOutgoingEvents(interval, start) {
	// `interval` is in seconds, `start` is in minutes
	var func = function func() {
		sendEvents = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.throttle(send, interval * 1000, { leading: false });
	};
	if (start) {
		setTimeout(func, start * 60000);
	} else {
		func();
	}
};

var stopOutgoingEvents = function stopOutgoingEvents(timeout) {
	// `timeout` is in minutes
	setTimeout(function () {
		sendEvents = function sendEvents() {};
	}, timeout * 60000);
};

var trackDOMContentLoaded = function trackDOMContentLoaded(Metrics) {
	var contentHasLoaded = function contentHasLoaded() {
		if (window.performance && window.performance.timing) {
			var _window$performance$t = window.performance.timing,
			    domInteractive = _window$performance$t.domInteractive,
			    navigationStart = _window$performance$t.navigationStart;

			Metrics.monitor('contentLoadTiming', domInteractive - navigationStart);
		}
	};

	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		contentHasLoaded();
	} else {
		document.addEventListener('DOMContentLoaded', contentHasLoaded);
	}
};

var trackWindowLoad = function trackWindowLoad(Metrics) {
	var windowHasLoaded = function windowHasLoaded() {
		if (window.performance && window.performance.timing) {
			var _window$performance$t2 = window.performance.timing,
			    domComplete = _window$performance$t2.domComplete,
			    navigationStart = _window$performance$t2.navigationStart;

			Metrics.monitor('windowLoadTiming', domComplete - navigationStart);
		}
	};

	if (document.readyState === 'complete') {
		windowHasLoaded();
	} else {
		document.addEventListener('load', windowHasLoaded);
	}
};

// Exports //

var Metrics = function () {
	function Metrics(_ref) {
		var name = _ref.name;

		_classCallCheck(this, Metrics);

		this.name = name;
		this.userInfo = __WEBPACK_IMPORTED_MODULE_3__user_info__["a" /* default */];

		throttleOutgoingEvents(10);
		throttleOutgoingEvents(60, 5);
		stopOutgoingEvents(30);

		trackDOMContentLoaded(this);
		trackWindowLoad(this);
	}

	_createClass(Metrics, [{
		key: 'monitor',
		value: function monitor(value) {
			var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
			var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'meter';

			var events = getEvents('monitoring');
			events.push(getMonitoringEvent(this.name, events, { value: value, type: type, count: count }));
			setEvents('monitoring', events);
			sendEvents('monitoring');
		}
	}]);

	return Metrics;
}();

/* harmony default export */ __webpack_exports__["a"] = (Metrics);

/***/ }),

/***/ "QbWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setCookie = function setCookie(name, value, days) {
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = ';' + expires + '=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

/* harmony default export */ __webpack_exports__["a"] = (setCookie);

/***/ }),

/***/ "R8JQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getCSRFToken__ = __webpack_require__("J6J4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getCookie__ = __webpack_require__("7dxP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCookie__ = __webpack_require__("QbWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetchRetry__ = __webpack_require__("mEf8");
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var apiToken = void 0;

var getCSRFCookie = function getCSRFCookie() {
	var csrfToken = null;
	var CSRFTokenFromCookie = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getCookie__["a" /* default */])('CSRFToken');

	if (CSRFTokenFromCookie) {
		csrfToken = CSRFTokenFromCookie;
	} else {
		csrfToken = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getCSRFToken__["a" /* default */])();
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setCookie__["a" /* default */])('CSRFToken', csrfToken);
	}

	return csrfToken;
};

var getBearerToken = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var data, response;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						if (!(typeof apiToken !== 'undefined')) {
							_context.next = 2;
							break;
						}

						return _context.abrupt('return', apiToken);

					case 2:
						data = null;
						_context.prev = 3;
						_context.next = 6;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fetchRetry__["a" /* default */])(url + '/v3/oauth/tokenFromSession', {
							method: 'POST',
							credentials: 'same-origin',
							headers: {
								'Content-Type': 'application/json',
								'X-CSRF-TOKEN': getCSRFCookie()
							}
						});

					case 6:
						response = _context.sent;
						_context.next = 9;
						return response.json();

					case 9:
						data = _context.sent;

						apiToken = data.result.payload[0].accessToken;
						return _context.abrupt('return', apiToken);

					case 14:
						_context.prev = 14;
						_context.t0 = _context['catch'](3);
						throw new Error(_context.t0);

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, _this, [[3, 14]]);
	}));

	return function getBearerToken() {
		return _ref.apply(this, arguments);
	};
}();

/* harmony default export */ __webpack_exports__["a"] = (getBearerToken);

/***/ }),

/***/ "RioI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchBar__ = __webpack_require__("4KX5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SocialChatMenu__ = __webpack_require__("El2X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SocialNotificationsMenu__ = __webpack_require__("KJQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SocialUserMenu__ = __webpack_require__("XU2w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMIconButton__ = __webpack_require__("GkAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMIconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMIconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_more_vert__ = __webpack_require__("WHRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_more_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_svg_icons_navigation_more_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities__ = __webpack_require__("CqnY");










var RightMenuGroup = function RightMenuGroup(_ref) {
	var support = _ref.support,
	    user = _ref.user,
	    useZendesk = _ref.useZendesk,
	    useZoomChat = _ref.useZoomChat,
	    hideSearchBar = _ref.hideSearchBar,
	    hideNotifications = _ref.hideNotifications;
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		'div',
		null,
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			null,
			!hideSearchBar && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SearchBar__["a" /* default */], null),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SocialChatMenu__["a" /* default */], {
				useZendesk: useZendesk,
				useZoomChat: useZoomChat,
				user: user,
				support: support
			}),
			!hideNotifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SocialNotificationsMenu__["a" /* default */], null),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SocialUserMenu__["a" /* default */], { user: user })
		)
	);
};

RightMenuGroup.defaultProps = {
	support: {},
	user: {},
	useZendesk: false,
	useZoomChat: false,
	hideSearchBar: false,
	hideNotifications: false
};

/* harmony default export */ __webpack_exports__["a"] = (RightMenuGroup);

/***/ }),

/***/ "UbF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'button.saveDraft': 'Guardar como borrador',
	'button.save': 'Guardar + Ruta',
	'translation.work': 'Trabajo',
	'translation.assignments': 'Asignaciones',
	'translation.new_assignment': 'Nueva Asignación',
	'translation.projects': 'Proyectos',
	'translation.contact_manager': 'Gerente de contacto',
	'translation.work_upload_tm': 'WorkUpload™',
	'translation.realtime': 'Tiempo real',
	'translation.talent': 'Talento',
	'translation.my_talent': 'Mi talento',
	'translation.find_talent': 'Buscar talentos',
	'translation.recruiting': 'Reclutamiento',
	'translation.tests': 'Pruebas',
	'translation.surveys': 'Encuestas',
	'translation.payments': 'Pagos',
	'translation.overview': 'Descripción general',
	'translation.invoices': 'Facturas',
	'translation.requests': 'Peticiones',
	'translation.funds': 'Fondos',
	'translation.add_funds': 'Añadir fondos',
	'translation.accounts': 'Cuentas',
	'translation.reports': 'Informes',
	'translation.dashboard': 'Cuadro de instrumentos',
	'translation.new_report': 'Nuevo Informe',
	'translation.all_reports': 'Todos los informes',
	'translation.analytics_dashboards': 'Cuadros de mando',
	'translation.custom_reports': 'Informes',
	'translation.talent_profile': 'Perfil de Talento',
	'translation.my_profile': 'Mi perfil',
	'translation.talent_pools': 'Piscinas de talento',
	'translation.my_work': 'Mi Trabajo',
	'translation.find_work': 'Buscar trabajo',
	'translation.search': 'Buscar',
	'translation.search_my_assignments': 'Buscar mis asignaciones',
	'translation.calendar': 'Calendario',
	'translation.ratings': 'Calificaciones',
	'translation.invitations': 'Usted tiene {0} invitaciones pendientes de la piscina del talento',
	'translation.view_invitations': 'Ver invitaciones',
	'translation.analytics': 'Analítica',
	'translation.talent_profile_op': 'Cuenta',
	'translation.my_profile_op': 'Perfil',
	'translation.tax_info': 'Información Fiscal',
	'translation.home': 'Hogar',
	'translation.orgstructure': 'Estructura organizacional',
	'translation.withholding_orders': 'Órdenes de retención'
});

/***/ }),

/***/ "WZmK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	'translation.work': 'Work',
	'translation.assignments': 'Assignments',
	'translation.new_assignment': 'New Assignment',
	'translation.projects': 'Projects',
	'translation.contact_manager': 'Contact Manager',
	'translation.work_upload_tm': 'WorkUpload™',
	'translation.realtime': 'Realtime',
	'translation.talent': 'Talent',
	'translation.find_talent': 'Find Talent',
	'translation.recruiting': 'Recruiting',
	'translation.tests': 'Tests',
	'translation.surveys': 'Surveys',
	'translation.payments': 'Payments',
	'translation.overview': 'Overview',
	'translation.invoices': 'Invoices',
	'translation.requests': 'Requests',
	'translation.funds': 'Funds',
	'translation.add_funds': 'Add Funds',
	'translation.accounts': 'Accounts',
	'translation.reports': 'Reports',
	'translation.dashboard': 'Dashboard',
	'translation.new_report': 'New Report',
	'translation.all_reports': 'All Reports',
	'translation.analytics_dashboards': 'Dashboards',
	'translation.custom_reports': 'Reports',
	'translation.talent_profile': 'Talent Profile',
	'translation.my_profile': 'My Profile',
	'translation.my_talent': 'My Talent',
	'translation.talent_pools': 'Labor Clouds',
	'translation.my_work': 'My Work',
	'translation.find_work': 'Find Work',
	'translation.search': 'Search',
	'translation.search_my_assignments': 'Search my assignments',
	'translation.calendar': 'Calendar',
	'translation.ratings': 'Ratings',
	'translation.invitations': 'You have {0} pending Labor Cloud invitations',
	'translation.view_invitations': 'View Invitations',
	'translation.analytics': 'Analytics',
	'translation.talent_profile_op': 'Account',
	'translation.my_profile_op': 'Profile',
	'translation.tax_info': 'Tax Info',
	'translation.home': 'Home',
	'translation.orgstructure': 'Organizational Structures',
	'translation.withholding_orders': 'Withholding Orders'
});

/***/ }),

/***/ "XU2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium__ = __webpack_require__("Extj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("CqnY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconMenu__ = __webpack_require__("xP5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_social_person__ = __webpack_require__("G2fq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_social_person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_social_person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem__ = __webpack_require__("qt5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMIconButton__ = __webpack_require__("GkAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMIconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMIconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMDivider__ = __webpack_require__("ajST");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SocialUserAvatar = function (_Component) {
	_inherits(SocialUserAvatar, _Component);

	function SocialUserAvatar() {
		_classCallCheck(this, SocialUserAvatar);

		return _possibleConstructorReturn(this, (SocialUserAvatar.__proto__ || Object.getPrototypeOf(SocialUserAvatar)).apply(this, arguments));
	}

	_createClass(SocialUserAvatar, [{
		key: 'render',
		value: function render() {

			var styles = {
				img: {
					position: "absolute",
					marginTop: "-17px",
					marginLeft: "-17px",
					width: "32px",
					height: "32px",
					border: "solid 0.5px #cecece"
				}
			};

			return this.props.avatar ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: styles.img,
				src: this.props.avatar }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_svg_icons_social_person___default.a, { color: '#ffffff' });
		}
	}]);

	return SocialUserAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var SocialUserMenu = function (_Component2) {
	_inherits(SocialUserMenu, _Component2);

	function SocialUserMenu() {
		_classCallCheck(this, SocialUserMenu);

		return _possibleConstructorReturn(this, (SocialUserMenu.__proto__ || Object.getPrototypeOf(SocialUserMenu)).apply(this, arguments));
	}

	_createClass(SocialUserMenu, [{
		key: 'updatePersona',
		value: function updatePersona(type) {
			var params = {
				seller: type === 'perform_work',
				buyer: type === 'create_work',
				dispatcher: type === 'dispatch_work'
			};
			__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({
				url: '/profile-edit/persona-toggle/' + type,
				type: 'post',
				data: params,
				beforeSend: function beforeSend(xhr) {
					xhr.setRequestHeader('X-CSRF-TOKEN', __WEBPACK_IMPORTED_MODULE_2__utilities__["a" /* default */].getCSRFToken());
				},
				success: function success() {
					window.location = '/home';
				}
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var styles = {
				menuItem: { fontFamily: 'Open Sans', color: '#646b6f' },
				menuItemActive: { fontFamily: 'Open Sans', color: '#F79626' }
			};

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMIconMenu___default.a,
				{
					iconButtonElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMIconButton___default.a,
						{ style: { verticalAlign: 'middle' } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialUserAvatar, { avatar: this.props.user.smallAvatarUri || 0 })
					),
					anchorOrigin: { horizontal: 'right', vertical: 'top' },
					targetOrigin: { horizontal: 'right', vertical: 'top' } },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem___default.a, {
					disabled: true,
					primaryText: this.props.user.email || 'your@email.here' }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMDivider___default.a, null),
				this.props.user.userMenu.map(function (item, index) {
					return item.divider ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMDivider___default.a, { key: 'divider-' + index }) : item.personatype ? item.personatype === 'perform_work' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ key: index },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem___default.a, {
							onClick: _this3.updatePersona.bind(_this3, item.personatype),
							primaryText: item.title,
							style: _this3.props.user.seller ? styles.menuItemActive : styles.menuItem })
					) : item.personatype === 'create_work' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ key: index },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem___default.a, {
							onClick: _this3.updatePersona.bind(_this3, item.personatype),
							primaryText: item.title,
							style: _this3.props.user.buyer ? styles.menuItemActive : styles.menuItem })
					) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ key: index },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem___default.a, {
							onClick: _this3.updatePersona.bind(_this3, item.personatype),
							primaryText: item.title,
							style: _this3.props.user.dispatcher ? styles.menuItemActive : styles.menuItem })
					) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__workmarket_front_end_components_dist_WMMenuItem___default.a, {
						key: index,
						href: item.href,
						onClick: item.action,
						primaryText: item.title,
						style: styles.menuItem });
				})
			);
		}
	}]);

	return SocialUserMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SocialUserMenu = __WEBPACK_IMPORTED_MODULE_1_radium___default()(SocialUserMenu));

/***/ }),

/***/ "XpYO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium__ = __webpack_require__("Extj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem__ = __webpack_require__("qt5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSvgIcon__ = __webpack_require__("WN9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSvgIcon__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var LeftNavMenuGroup = function (_Component) {
	_inherits(LeftNavMenuGroup, _Component);

	function LeftNavMenuGroup() {
		_classCallCheck(this, LeftNavMenuGroup);

		return _possibleConstructorReturn(this, (LeftNavMenuGroup.__proto__ || Object.getPrototypeOf(LeftNavMenuGroup)).apply(this, arguments));
	}

	_createClass(LeftNavMenuGroup, [{
		key: 'render',
		value: function render() {
			var styles = {
				heading: {
					style: {
						marginTop: '18px',
						lineHeight: '24px',
						maxHeight: '24px',
						height: '24px',
						minHeight: '24px',
						color: 'rgba(0, 0, 0, 0.5)',
						fontSize: '1rem',
						fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
						fontWeight: 500,
						cursor: 'default',
						backgroundColor: 'transparent'
					},
					innerDivStyle: function innerDivStyle(href) {
						return location.pathname === href ? {
							padding: '0px 16px 0px 80px',
							fontSize: '.95rem',
							fontFamily: 'Open Sans',
							color: '#f7961d'
						} : {
							padding: '0px 16px 0px 80px',
							fontSize: '.95rem',
							fontFamily: 'Open Sans',
							color: '#8d9092'
						};
					},
					leftIconStyle: {
						marginTop: '0px',
						marginBottom: '0px',
						top: '1px',
						left: '8px'
					},
					longLabelDivStyle: {
						marginTop: '18px',
						lineHeight: '24px',
						maxHeight: '24px',
						height: '24px',
						minHeight: '38px',
						color: 'rgba(0, 0, 0, 0.5)',
						fontSize: '1rem',
						fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
						fontWeight: 500,
						cursor: 'pointer',
						backgroundColor: 'transparent',
						whiteSpace: 'pre-wrap'
					},
					longLabelIconStyle: {
						marginTop: '0px',
						marginBottom: '0px',
						top: '5px',
						left: '10px'
					}
				},
				list: {
					itemStyle: {
						lineHeight: '25px',
						maxHeight: '25px',
						height: '25px',
						minHeight: '25px',
						marginBottom: '5px'
					},
					innerDivStyle: function innerDivStyle(href) {
						return location.pathname === href ? {
							fontFamily: 'Open Sans',
							fontSize: '1rem',
							color: '#f7961d',
							padding: '5px 16px 5px 80px'
						} : {
							fontFamily: 'Open Sans',
							fontSize: '.95rem',
							color: '#8d9092',
							padding: '5px 16px 5px 80px'
						};
					}
				}
			};

			if (this.props.navMenuItems.length < 1) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					null,
					' loading... '
				);
			}

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				null,
				this.props.navMenuItems.map(function (el, index) {
					return el.style === undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ key: index },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
							style: styles.heading.style,
							innerDivStyle: styles.heading.innerDivStyle(el.href),
							href: el.href,
							disabled: true,
							leftIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSvgIcon___default.a,
								{ style: styles.heading.leftIconStyle, color: 'inherit' },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: el.iconPath, fill: '#8d9092' })
							),
							primaryText: el.label }),
						el.items.map(function (item) {
							return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
								style: styles.list.itemStyle,
								innerDivStyle: styles.list.innerDivStyle(item.href),
								href: item.href,
								key: item.title,
								primaryText: item.title });
						})
					) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'a',
						{ key: index, href: el.href },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMMenuItem___default.a, {
							style: styles.heading.longLabelDivStyle,
							innerDivStyle: styles.heading.innerDivStyle(el.href),
							disabled: true,
							leftIcon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMSvgIcon___default.a,
								{ style: styles.heading.longLabelIconStyle, color: 'inherit' },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: el.iconPath, fill: '#8d9092' })
							),
							primaryText: el.label })
					);
				})
			);
		}
	}]);

	return LeftNavMenuGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LeftNavMenuGroup = __WEBPACK_IMPORTED_MODULE_1_radium___default()(LeftNavMenuGroup));

/***/ }),

/***/ "a7aZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template__ = __webpack_require__("D/33");




// eslint-disable-next-line max-len
// TODO: @artivilla import this script across all desktop views that don't have mainnav on their page

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__template__["a" /* default */], {
	encryptedId: config.encryptedId,
	isInvitation: config.isInvitation,
	csrf: config.csrf,
	campaignText: config.campaignText,
	companyNumber: config.companyNumber,
	googleRecaptchaSiteKey: config.googleRecaptchaSiteKey
}), document.getElementById('landing-page-bucket'));

/***/ }),

/***/ "aRfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__ = __webpack_require__("T96S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__funcs_wmFetch__ = __webpack_require__("Nusj");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();






var SwitchModal = function SwitchModal(props) {
	var isOpen = props.isOpen,
	    onClose = props.onClose,
	    personaMode = props.personaMode;

	var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(personaMode),
	    _useState2 = _slicedToArray(_useState, 2),
	    newPersonaMode = _useState2[0],
	    setNewPersonaMode = _useState2[1];

	var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
	    _useState4 = _slicedToArray(_useState3, 2),
	    saving = _useState4[0],
	    setSaving = _useState4[1];

	var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
	    _useState6 = _slicedToArray(_useState5, 2),
	    errorMessage = _useState6[0],
	    setErrorMessage = _useState6[1];

	var onChange = function onChange(e) {
		var value = e.detail.value;

		setNewPersonaMode(value);
	};

	var handleClose = function handleClose() {
		setNewPersonaMode(personaMode);
		setErrorMessage(null);
		onClose();
	};

	var handleSave = function handleSave() {
		setSaving(true);
		setErrorMessage(null);

		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__funcs_wmFetch__["a" /* default */])('/v3/user/update-persona', { newPersonaMode: newPersonaMode }).then(function () {
			onClose();
			setTimeout(function () {
				window.location = '/home';
			}, 100);
		}).catch(function (error) {
			setErrorMessage(error.message || 'An error occurred');
			setSaving(false);
		});
	};

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["d" /* SdfFocusPane */],
		{
			'data-attr-id': 'persona-mode-switch-modal',
			portalEnabled: true,
			closeable: true,
			size: 'sm',
			visible: isOpen,
			heading: 'Switch experience',
			closeIconTitle: 'Close',
			onSdfDismiss: handleClose,
			acceptLabel: 'Update',
			disableAcceptButton: personaMode === newPersonaMode,
			busyAcceptButton: saving,
			onSdfAccept: handleSave
		},
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ className: 'p-4' },
			errorMessage && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["e" /* SdfAlert */],
				{
					'data-attr-id': 'persona-mode-switch-modal-error-banner',
					className: 'mb-4',
					type: 'banner',
					size: 'sm',
					status: 'error'
				},
				errorMessage
			),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["f" /* SdfRadioGroup */],
				{
					'data-attr-id': 'persona-mode-switch-radios',
					label: 'Choose experience',
					onSdfChange: onChange,
					value: newPersonaMode
				},
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["g" /* SdfRadioButton */], { value: 'BUYER', label: 'Client' }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["g" /* SdfRadioButton */], { value: 'SELLER', label: 'Contractor' }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__waypoint_react_components__["g" /* SdfRadioButton */], { value: 'DISPATCHER', label: 'Team agent' })
			)
		)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (SwitchModal);

/***/ }),

/***/ "cx/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_common_WMThemeProvider__ = __webpack_require__("9r89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_common_WMThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_common_WMThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Navigation__ = __webpack_require__("pjE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__funcs_ajaxSendInit__ = __webpack_require__("vEsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__funcs_translation__ = __webpack_require__("94r8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_user_info__ = __webpack_require__("36q6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__funcs_wmFetch__ = __webpack_require__("Nusj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__funcs_wmNotify__ = __webpack_require__("hpUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_WaypointShellNav_ShellNavigation__ = __webpack_require__("80dd");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












if (document.querySelector('meta[name="isDesktop"]').getAttribute('content') === 'true') {
	// fix for ajax requests on components
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__funcs_ajaxSendInit__["a" /* default */])();

	var loadConfig = function loadConfig() {
		// from /partials/navigation/app.jsp
		var navConfig = window.navConfig;
		var isBuyer = navConfig.currentUser.buyer;
		var isSellerOrgPayNavigation = navConfig.currentUser.isSellerOrgPayNavigation;
		var isBuyerOrgPayNavigation = navConfig.currentUser.isBuyerOrgPayNavigation;
		var canRedirectToBuyerHome = navConfig.currentUser.canRedirectToBuyerHome;
		var canRedirectToSellerHome = navConfig.currentUser.canRedirectToSellerHome;

		var homePageLink = canRedirectToBuyerHome ? "/home/company" : canRedirectToSellerHome ? "/my-home" : "/home";

		var homeNavItem = {
			label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.home"),
			iconPath: 'M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z',
			href: homePageLink
		};

		if (isBuyer) {
			navConfig.navMenuItems = [{
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.work"),
				iconPath: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z',
				items: [{ href: '/assignments/', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.assignments") }, { href: '/projects', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.projects") }, { href: '/addressbook', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.contact_manager") }, { href: '/assignments/upload', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.work_upload_tm") }, { href: '/realtime', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.realtime") }]
			}, {
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.talent"),
				iconPath: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
				items: [{ href: '/talent', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.find_talent") }, { href: '/labor-clouds', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.talent_pools") }, { href: '/recruiting', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.recruiting") }, { href: '/lms/manage/list_view', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.tests") }, { href: '/lms/manage/surveys', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.surveys") }]
			}];

			if (navConfig.hasCreateWork) {
				if (navConfig.useNewCreateWork) {
					navConfig.navMenuItems[0].items.splice(1, 0, { href: '/manage/create', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.new_assignment") });
				} else {
					navConfig.navMenuItems[0].items.splice(1, 0, { href: '/assignments/?launchAssignmentModal&introdisabled', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.new_assignment") });
				}
			}

			if (navConfig.hasOrgStructureFeatureEnabled) {
				var orgStructureItem = {
					label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.orgstructure"),
					iconPath: 'M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z',
					href: '/org-structure',
					style: 'useOverwriteStyles'
				};
				navConfig.navMenuItems.unshift(orgStructureItem);
			}

			if (isBuyerOrgPayNavigation) {
				navConfig.navMenuItems.splice(0, 1); // Remove the "Work" nav menu item for Org Pay Clients
			}

			var payItems = [{ href: navConfig.hasImpoundDisbursementEnabled ? '/payments/invoices/payables' : '/payments',
				title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])(navConfig.hasImpoundDisbursementEnabled ? "translation.invoices" : "translation.overview") }];

			if (navConfig.pay) {
				payItems.push({ href: '/pay', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.requests") });
			}

			if (navConfig.hasImpoundDisbursementEnabled) {
				payItems.push({ href: '/accounts', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.accounts") });
			} else {
				if (navConfig.hasAdpTrustAddFundsFeature) {
					if (navConfig.clientCanViewAddFundsInMenu) {
						payItems.push({ href: '/funds/add', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.add_funds") }, {
							href: '/accounts', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.accounts")
						});
					} else {
						payItems.push({
							href: '/accounts', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.accounts")
						});
					}
				} else {
					payItems.push({ href: '/funds/add', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.add_funds") }, {
						href: '/accounts', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.accounts")
					});
				}
			}

			if (isBuyerOrgPayNavigation && navConfig.hasOmpClientHomepageProjectAndContactManagerFeature) {
				payItems.push({ href: '/projects', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.projects") }, { href: '/addressbook', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.contact_manager") });
			}

			navConfig.navMenuItems.push({
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.payments"),
				iconPath: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z',
				items: payItems

			});

			var reportItems = [];
			if (navConfig.hasViewCompanyAnalyticsDashboardPermission) {
				reportItems.push({ href: '/analytics-dashboards', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.analytics_dashboards") });
			}
			if (navConfig.hasReportingPermissions || navConfig.hasAdvancedReportingPermissions) {
				reportItems.push({ href: '/custom-reports', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])('translation.custom_reports') });
			}

			if (reportItems && reportItems.length) {
				var reportLabel = "translation.analytics";
				navConfig.navMenuItems.push({
					label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])(reportLabel),
					iconPath: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z',
					items: reportItems
				});
			}
		} else {
			navConfig.navMenuItems = isSellerOrgPayNavigation ? [{
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.talent_profile_op"),
				iconPath: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
				items: [{ href: '/profile', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.my_profile_op") }, { href: '/account/tax', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.tax_info") }]
			}, {
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.payments"),
				iconPath: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z',
				items: [{ href: '/payments', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.overview") }, { href: '/accounts', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.accounts") }]
			}] : [{
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.talent_profile"),
				iconPath: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
				items: [{ href: '/profile', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.my_profile") }, { href: '/lms/view', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.tests") }, { href: '/search-groups', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.talent_pools") }]
			}, {
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.work"),
				iconPath: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z',
				items: [{ href: '/assignments', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.my_work") }, { href: '/worker/browse', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.find_work") }, { href: '/assignments?calendar=on', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.calendar") }, { href: '/ratings', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.ratings") }]
			}, {
				label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.payments"),
				iconPath: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z',
				items: [{ href: '/payments', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.overview") }, { href: '/accounts', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])("translation.accounts") }]
			}];

			if (!isSellerOrgPayNavigation) {
				var _reportItems = [];
				if (navConfig.canViewMyReports) {
					_reportItems.push({ href: '/custom-reports', title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])('translation.custom_reports') });
				}

				if (_reportItems && _reportItems.length) {
					var _reportLabel = "translation.analytics";
					navConfig.navMenuItems.push({
						label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__funcs_translation__["a" /* default */])(_reportLabel),
						iconPath: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z',
						items: _reportItems
					});
				}
			}
		}

		// Add the home item at the beginning of the nav menu items
		if (navConfig.hasWaypointSquirtleShellFeature) {
			navConfig.navMenuItems.unshift(homeNavItem);
		}

		if (__WEBPACK_IMPORTED_MODULE_6__core_user_info__["a" /* default */].isSupport) {
			var logoutItem = navConfig.currentUser.userMenu.find(function (it) {
				return it.href && it.href.startsWith('/logout');
			});
			if (logoutItem) {
				logoutItem.title = 'End Session';
				logoutItem.href = null;
				logoutItem.action = function () {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__funcs_wmFetch__["a" /* default */])('/v3/authSession/authSwitch/end-support-session').then(function (payload) {
						var _payload = _slicedToArray(payload, 1),
						    companyId = _payload[0].companyId;

						var adminSupportPage = '/admin/manage/company/customer_support/' + companyId;
						window.location.href = adminSupportPage;
					}).catch(function (error) {
						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__funcs_wmNotify__["a" /* default */])({
							message: error,
							type: 'danger'
						});
					});
				};
			}
		}

		return navConfig;
	};

	var toKebabCase = function toKebabCase(str) {
		return str && str.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase();
	};

	var mapIcon = function mapIcon(label) {
		// Map section labels to icon names as needed
		var iconMap = {
			account: 'user',
			analytics: 'ext-mdi-show-chart',
			home: 'home',
			'organizational-structures': 'action-view-settings',
			payments: 'institution-bank',
			reports: 'ext-mdi-show-chart',
			talent: 'user-group',
			'talent profile': 'user',
			work: 'work',
			'Assignments': 'work'
		};
		return iconMap[toKebabCase(label)] || 'user';
	};

	var mapToNewMenuFormat = function mapToNewMenuFormat(menuFromBE) {
		return menuFromBE.map(function (section) {
			return {
				id: toKebabCase(section.label),
				title: section.label,
				hash: section.href || null,
				icon: mapIcon(section.label),
				hasChildren: Array.isArray(section.items) && section.items.length > 0,
				children: (section.items || []).map(function (child) {
					return {
						id: toKebabCase(child.title),
						title: child.title,
						hash: child.href
					};
				})
			};
		});
	};

	var config = loadConfig();

	var NavigationApp = function (_Component) {
		_inherits(NavigationApp, _Component);

		function NavigationApp() {
			_classCallCheck(this, NavigationApp);

			return _possibleConstructorReturn(this, (NavigationApp.__proto__ || Object.getPrototypeOf(NavigationApp)).apply(this, arguments));
		}

		_createClass(NavigationApp, [{
			key: 'render',
			value: function render() {
				return config.hasWaypointSquirtleShellFeature ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_WaypointShellNav_ShellNavigation__["a" /* default */], {
					showSupportBanner: __WEBPACK_IMPORTED_MODULE_6__core_user_info__["a" /* default */].isSupport,
					newConfig: _extends({}, config, {
						navMenuItems: mapToNewMenuFormat(config.navMenuItems)
					})
				}) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_common_WMThemeProvider___default.a,
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Navigation__["a" /* default */], {
						config: config,
						showSupportBanner: __WEBPACK_IMPORTED_MODULE_6__core_user_info__["a" /* default */].isSupport
					})
				);
			}
		}]);

		return NavigationApp;
	}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

	var renderApp = function renderApp() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationApp, null), document.querySelector('#wm-main-nav'));
	};

	if (config.hasWaypointSquirtleShellFeature) {
		if (!window.SynergConfig) {
			console.error('SynergConfig is missing');
		} else {
			initializeSynergConfig();
			renderApp();
		}
	} else {
		renderApp();
	}
}

/***/ }),

/***/ "hpUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
	var snackbarContainer = document.querySelector('.mdl-js-snackbar');

	var isSnackbarReady = function isSnackbarReady() {
		return window.MaterialSnackbar && snackbarContainer.MaterialSnackbar;
	};

	var initSnackbar = function initSnackbar() {
		var snacks = Array.isArray(options) ? options : [options];

		return snacks.map(function (snack) {
			var snackbarOptions = typeof snack === 'string' ? { message: snack } : snack;
			/* Default way of showing snackbar, sets a timeout to hide it which cannot be disabled
   	snackbarContainer.MaterialSnackbar.showSnackbar(snackbarOptions);
   */
			var actionHandler = snackbarOptions.actionHandler,
			    actionText = snackbarOptions.actionText,
			    message = snackbarOptions.message;


			var hasActionAndText = typeof actionHandler === 'function' && typeof actionText === 'string' && actionText.trim().length > 0;

			var snackBarText = snackbarContainer.querySelector('.mdl-snackbar__text');
			snackBarText.textContent = message;

			var snackBarActionButton = snackbarContainer.querySelector('.mdl-snackbar__action');

			snackBarActionButton.textContent = hasActionAndText ? actionText : 'Close';
			snackbarContainer.removeAttribute('aria-hidden');
			snackBarActionButton.removeAttribute('aria-hidden');
			snackBarActionButton.removeAttribute('tabindex');
			snackBarActionButton.onclick = function () {
				if (hasActionAndText) {
					actionHandler();
				}
				if (snackbarContainer.MaterialSnackbar.cleanup_) {
					snackbarContainer.MaterialSnackbar.cleanup_();
				} else {
					snackbarContainer.classList.remove('mdl-snackbar--active');
				}
				snackBarActionButton.setAttribute('tabindex', '-1');
			};
			snackbarContainer.classList.add('mdl-snackbar--active');
		});
	};

	if (isSnackbarReady()) {
		initSnackbar();
	} else {
		var snackCheck = setInterval(function () {
			// ensure that material design scripts have been executed
			if (isSnackbarReady()) {
				clearInterval(snackCheck);
				initSnackbar();
			}
			return null;
		}, 1000);
	}
});

/***/ }),

/***/ "m3YH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	landingPageHeader: {
		width: '90%',
		boxSizing: 'border-box',
		margin: '0 auto',
		padding: '25px 25px 10px 25px',
		display: 'flex',
		flexWrap: 'wrap'
	},
	landingPageText: {
		flex: '1',
		marginTop: '5px'
	},
	landingPageButtonContainer: {
		flex: '1',
		display: 'flex',
		alignItems: 'flex-start',
		flexWrap: 'wrap'
	},
	buttonContainer: {
		flex: '1',
		minWidth: '200px',
		margin: '0 5px 3px 5px'
	},
	tinyText: {
		textAlign: 'center',
		fontSize: '10px',
		marginTop: '5px'
	},
	descriptionContainer: {
		width: '90%',
		margin: '25px auto 0 auto',
		padding: '25px',
		whiteSpace: 'pre-wrap'
	},
	hideForm: {
		display: 'none'
	},
	formContainer: {
		width: '100%',
		maxWidth: '400px',
		margin: '25px auto 0 auto',
		padding: '25px 25px 40px 25px'
	},
	registerButton: {
		marginTop: '1.5em'
	},
	tos: {
		fontSize: '10px',
		textAlign: 'center',
		width: '100%',
		marginTop: '10px'
	},
	landingPageError: {
		padding: '10px'
	}
});

/***/ }),

/***/ "mEf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__("j9g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var wait = function wait(ms) {
	return new Promise(function (r) {
		return setTimeout(r, ms);
	});
};

var fetchRetry = function fetchRetry(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var times = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
	var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1500;
	return new Promise(function () {
		var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
			var resp, _resp;

			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.prev = 0;
							_context.next = 3;
							return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()(url, options);

						case 3:
							resp = _context.sent;

							if (!(resp.status === 200)) {
								_context.next = 6;
								break;
							}

							return _context.abrupt('return', resolve(resp));

						case 6:
							throw new Error(resp);

						case 9:
							_context.prev = 9;
							_context.t0 = _context['catch'](0);

							if (!(times - 1 > 0)) {
								_context.next = 24;
								break;
							}

							_context.next = 14;
							return wait(delay);

						case 14:
							_context.prev = 14;
							_context.next = 17;
							return fetchRetry(url, options, times - 1, delay);

						case 17:
							_resp = _context.sent;
							return _context.abrupt('return', resolve(_resp));

						case 21:
							_context.prev = 21;
							_context.t1 = _context['catch'](14);
							return _context.abrupt('return', reject(_context.t1));

						case 24:

							reject(_context.t0);

						case 25:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this, [[0, 9], [14, 21]]);
		}));

		return function (_x4, _x5) {
			return _ref.apply(this, arguments);
		};
	}());
};

/* harmony default export */ __webpack_exports__["a"] = (fetchRetry);

/***/ }),

/***/ "pjE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium__ = __webpack_require__("Extj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_radium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_radium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMAppBar__ = __webpack_require__("QQgz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMAppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMAppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMDrawer__ = __webpack_require__("GTvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeftNavMenu_LeftNavMenuGroup__ = __webpack_require__("XpYO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RightNavMenuGroup__ = __webpack_require__("RioI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMSnackbar__ = __webpack_require__("zfs3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMLinearProgress__ = __webpack_require__("XRZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMLinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMLinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__funcs_ajaxSendInit__ = __webpack_require__("vEsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities__ = __webpack_require__("CqnY");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Navigation = function (_Component) {
	_inherits(Navigation, _Component);

	function Navigation(props) {
		_classCallCheck(this, Navigation);

		var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

		_this.renderSupportBanner = function () {
			if (_this.props.showSupportBanner && !_this.state.DynamicSupportBanner) {
				__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "pTHk")).then(function (component) {
					_this.setState({ DynamicSupportBanner: component.default, appDrawerTop: '124px' });
				});
			}
		};

		_this.addSmartBannerEventListeners = function () {
			document.addEventListener('smartbanner.exit', function () {
				return _this.setState({ appDrawerTop: '64px' });
			});
			document.addEventListener('smartbanner.view', function () {
				return _this.setState({ appDrawerTop: '146px' });
			});
		};

		_this.state = {
			open: props.config.isNavPinnedOpen,
			DynamicSupportBanner: null,
			appDrawerTop: '64px'
		};
		return _this;
	}

	_createClass(Navigation, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			/*Oh Jquery Monolith Shimmy Shim Shim Mounting Shim*/
			__WEBPACK_IMPORTED_MODULE_8_jquery___default()(document).ready(function () {
				return _this2.jQueryContentMoveShim(_this2.props.config.isNavPinnedOpen);
			});
			this.renderSupportBanner();
			this.addSmartBannerEventListeners();
		}
	}, {
		key: 'handleToggleNavMenu',
		value: function handleToggleNavMenu() {
			this.setState({ open: !this.state.open });
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__funcs_ajaxSendInit__["a" /* default */])();
			__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.post('/nav/set_preferences', { open: !this.state.open });
			this.jQueryContentMoveShim(!this.state.open);
		}
	}, {
		key: 'jQueryContentMoveShim',
		value: function jQueryContentMoveShim(isOpen) {
			/*Oh Jquery Monolith Shimmy Shim Shim */
			if (isOpen && !__WEBPACK_IMPORTED_MODULE_11__utilities__["a" /* default */].browser.isSmallMobile()) {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#outer-container').css('margin-left', '240px');
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.site-footer').css('margin-left', '240px');
			} else {
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()('#outer-container').css('margin-left', '0px');
				__WEBPACK_IMPORTED_MODULE_8_jquery___default()('.site-footer').css('margin-left', '0px');
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var styles = {
				Drawer: {
					position: 'fixed',
					top: !__WEBPACK_IMPORTED_MODULE_11__utilities__["a" /* default */].appBarRemoved() ? this.state.appDrawerTop : 0,
					zIndex: '1200',
					paddingBottom: '64px',
					bottom: '0',
					height: 'auto'
				},
				AppBar: { backgroundColor: '#f7961d', position: 'fixed', left: 0, right: 0, zIndex: '1200' },
				LeftNavMobileHeader: { height: '64px', backgroundColor: '#f7961d', paddingTop: '8px' },
				LeftNavMobileHeaderLogo: { paddingTop: '7px', paddingLeft: '14px', float: 'left' },
				LeftNavMobileHeaderIcon: { float: 'right' },
				logo: {
					position: 'absolute',
					top: '50%',
					transform: 'translateY(-50%)',
					width: 140,
					height: 33
				}
			};

			if (__WEBPACK_IMPORTED_MODULE_11__utilities__["a" /* default */].appBarRemoved()) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WMUploader, { status: this.props.config.uploadStatus, message: this.props.config.uploadMessage })
				);
			}

			var DynamicSupportBanner = this.state.DynamicSupportBanner;


			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_3__workmarket_front_end_components_dist_WMDrawer___default.a,
					{
						docked: __WEBPACK_IMPORTED_MODULE_11__utilities__["a" /* default */].browser.isSmallMobile() ? false : true,
						open: this.state.open,
						width: 240,
						containerStyle: styles.Drawer },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LeftNavMenu_LeftNavMenuGroup__["a" /* default */], { navMenuItems: this.props.config.navMenuItems, activePage: this.props.config.breadcrumbPage })
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ style: styles.AppBar },
					DynamicSupportBanner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DynamicSupportBanner, null),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__workmarket_front_end_components_dist_WMAppBar___default.a, {
						title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'a',
							{ href: '/home' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
								alt: 'Work Market Logo',
								src: this.props.config.adpWMlogoURI,
								style: styles.logo
							})
						),
						iconElementRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__RightNavMenuGroup__["a" /* default */], {
							useZendesk: this.props.config.useZendesk,
							useZoomChat: this.props.config.useZoomChat,
							user: this.props.config.currentUser,
							support: this.props.config.support,
							hideSearchBar: this.props.config.currentUser.isSellerOrgPayNavigation,
							hideNotifications: this.props.config.currentUser.isSellerOrgPayNavigation
						}),
						onLeftIconButtonClick: this.handleToggleNavMenu.bind(this)
					})
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WMUploader, { status: this.props.config.uploadStatus, message: this.props.config.uploadMessage })
			);
		}
	}]);

	return Navigation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var WMUploader = function (_Component2) {
	_inherits(WMUploader, _Component2);

	function WMUploader(props) {
		_classCallCheck(this, WMUploader);

		var _this3 = _possibleConstructorReturn(this, (WMUploader.__proto__ || Object.getPrototypeOf(WMUploader)).call(this, props));

		_this3.state = {
			status: props.status
		};
		return _this3;
	}

	_createClass(WMUploader, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.checkStatus();
		}
	}, {
		key: 'checkStatus',
		value: function checkStatus() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.getJSON('/uploadProgress/progress', function (res) {
				if (res && res.data && !__WEBPACK_IMPORTED_MODULE_9_underscore___default.a.isUndefined(res.data.uploadProgress)) {
					setTimeout(function () {
						_this4.setState({ status: res.data.uploadProgress });
					}, 2000);

					if (res.data.uploadProgress === 1) {
						setTimeout(function () {
							_this4.setState({ status: 0 });
						}, 12000);
					}
				} else {
					setTimeout(_this4.checkStatus, 5000);
				}
			});
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.props.status > 0 && this.props.status < 1) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__workmarket_front_end_components_dist_WMSnackbar___default.a, { style: { zIndex: '1200' }, bodyStyle: { backgroundColor: 'rgba(0, 0, 0, 0.74)' },
					open: !!this.state.status,
					message: this.state.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						null,
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							null,
							this.props.message.done.title
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: { paddingLeft: '20px' } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'a',
								{ href: this.props.message.done.link.href },
								' ',
								this.props.message.done.link.text
							)
						)
					) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						null,
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							null,
							this.props.message.start.title
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__workmarket_front_end_components_dist_WMLinearProgress___default.a, { style: {
								position: 'absolute',
								top: '24px',
								width: '150px',
								margin: '0 0 0 96px'
							},
							color: '#F79626',
							mode: 'indeterminate'
						})
					)
				});
			}
			return null;
		}
	}]);

	return WMUploader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Navigation = __WEBPACK_IMPORTED_MODULE_1_radium___default()(Navigation));

/***/ }),

/***/ "sumK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__waypoint_react_components__ = __webpack_require__("T96S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__funcs_wmFetch__ = __webpack_require__("Nusj");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





var NotificationsBtn = function NotificationsBtn() {
	var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
	    _useState2 = _slicedToArray(_useState, 2),
	    alertCount = _useState2[0],
	    setAlertCount = _useState2[1];

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__funcs_wmFetch__["a" /* default */])('/v3/user/notifications', {}).then(function (res) {
			var payload = res[0];
			var unreadInfo = payload['unreadNotifications'];
			if (unreadInfo) {
				setAlertCount(unreadInfo['unreadAlertCount']);
			}
		}).catch(function (err) {
			console.error('Failed to fetch notifications:', err);
		});
	}, []);

	var handleClick = function handleClick() {
		if (alertCount > 0) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__funcs_wmFetch__["a" /* default */])('/v3/user/notification/read_all', {}).then(function () {
				window.location.href = '/notifications/active';
			}).catch(function (err) {
				window.location.href = '/notifications/active';
			});
		} else {
			window.location.href = '/notifications/active';
		}
	};

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__waypoint_react_components__["h" /* SfcShellAppBarIcon */], {
		'data-attr-id': 'notifications-btn',
		slot: 'icons',
		icon: 'alert-notification',
		label: 'Notifications',
		alertCount: alertCount,
		onClick: handleClick
	});
};

/* harmony default export */ __webpack_exports__["a"] = (NotificationsBtn);

/***/ }),

/***/ "uHhO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone__ = __webpack_require__("BMgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__csrf__ = __webpack_require__("JZtJ");



/* harmony default export */ __webpack_exports__["a"] = (function (method, model, options) {
	__WEBPACK_IMPORTED_MODULE_0_backbone__["a" /* default */].sync.call(this, method, model, Object.assign({}, options, {
		emulateJSON: false,
		emulateHTTP: true,
		headers: {
			'X-CSRF-Token': __WEBPACK_IMPORTED_MODULE_1__csrf__["a" /* default */]
		}
	}));
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vEsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getCSRFToken__ = __webpack_require__("J6J4");





var ajaxSendInit = function ajaxSendInit() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ajaxSend(function (elm, xhr, s) {

		if (s.type === 'POST' || s.type === 'PUT' || s.type === 'DELETE') {
			xhr.setRequestHeader('X-CSRF-Token', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getCSRFToken__["a" /* default */])());
		}
	});
};

ajaxSendInit();

/* harmony default export */ __webpack_exports__["a"] = (ajaxSendInit);

/***/ }),

/***/ "xuII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__waypoint_react_components__ = __webpack_require__("T96S");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var styles = {
	linkList: {
		paddingInlineStart: 0,
		listStyle: 'none'
	},
	linkListItem: {
		margin: '0 0 1rem 0',
		display: 'flex'
	}
};

var HelpLinksModal = function HelpLinksModal(props) {
	var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    isHelpModalOpen = _useState2[0],
	    setIsHelpModalOpen = _useState2[1];

	var useZoomChat = props.useZoomChat;

	var links = [].concat(_toConsumableArray(useZoomChat ? [] : [{
		href: 'mailto:mysupport@workmarket.com',
		icon: 'action-email',
		text: 'mysupport@workmarket.com'
	}]), [{
		href: 'tel:+1-917-877-9500',
		icon: 'phone',
		text: '917-877-9500'
	}, {
		href: 'https://workmarket.zendesk.com/hc/en-us',
		icon: 'action-help',
		text: 'Help Center'
	}, {
		href: 'http://status.workmarket.com',
		icon: 'status-flagged',
		text: 'Status Page'
	}, {
		href: '/privacy',
		icon: null,
		text: 'Privacy statement'
	}, {
		href: '/tos',
		icon: null,
		text: 'Terms of service'
	}]);

	var handleChatClick = function handleChatClick() {
		if (window.zoomCampaignSdk) {
			window.zoomCampaignSdk.open();
			window.zoomCampaignSdk.show();
			window.zoomCampaignSdk.on('close', function () {
				return window.zoomCampaignSdk.hide();
			});
		}
		setIsHelpModalOpen(false);
	};

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
		null,
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__waypoint_react_components__["h" /* SfcShellAppBarIcon */], {
			'data-attr-id': 'help-btn',
			slot: 'icons',
			icon: 'action-help',
			label: 'Help',
			onClick: function onClick() {
				setIsHelpModalOpen(true);
			}
		}),
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			__WEBPACK_IMPORTED_MODULE_3__waypoint_react_components__["d" /* SdfFocusPane */],
			{
				'data-attr-id': 'help-modal',
				closeable: true,
				size: 'sm',
				visible: isHelpModalOpen,
				heading: 'Help',
				closeIconTitle: 'Close',
				onSdfDismiss: function onSdfDismiss() {
					setIsHelpModalOpen(false);
				},
				hideAcceptButton: true,
				hideDismissButton: true
			},
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'ul',
				{ className: 'mx-8', style: styles.linkList },
				useZoomChat && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'li',
					{ style: styles.linkListItem },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						__WEBPACK_IMPORTED_MODULE_3__waypoint_react_components__["i" /* SdfLink */],
						{ onClick: handleChatClick, onKeyPress: handleChatClick },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__waypoint_react_components__["j" /* SdfIcon */], { icon: 'action-chat', className: 'mr-1' }),
						'Chat with us'
					)
				),
				links.map(function (link, idx) {
					return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'li',
						{
							key: idx,
							style: styles.linkListItem,
							className: '' + (idx === 0 || idx === 2 ? 'pb-4 border-0 border-b-1 border-solid border-divider' : '')
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_3__waypoint_react_components__["i" /* SdfLink */],
							{ href: link.href },
							link.icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__waypoint_react_components__["j" /* SdfIcon */], { icon: link.icon, className: 'mr-1' }),
							link.text
						)
					);
				})
			)
		), document.body)
	);
};

/* harmony default export */ __webpack_exports__["a"] = (HelpLinksModal);

/***/ }),

/***/ "yg9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORG_STRUCTURE; });
/**
 * Contains feature flags which are stored in the settings service
 */

var ORG_STRUCTURE = '/org-structure';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  ORG_STRUCTURE: ORG_STRUCTURE
});

/***/ })

},[13]);


// WEBPACK FOOTER //
// invitationlandingpage.js